import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1, 2),
    height: '100%',
    backgroundColor: ({ isActive }) =>
      isActive ? theme.palette.grey[200] : 'inherit'
  }
}));

export default useStyles;
